import { useMutation } from '@tanstack/vue-query';
import { getApi } from '../api';

export default () => useMutation({
  mutationFn: (credentialId: string) => {
    const { api, baseURL } = getApi();
    return api
      .delete(`/api/passkeys/${credentialId}`, { baseURL })
      .then((res) => res.data);
  },
});
